import { render, staticRenderFns } from "./OrmQuoteImages.vue?vue&type=template&id=76a7ee2f&scoped=true"
import script from "./OrmQuoteImages.vue?vue&type=script&lang=js"
export * from "./OrmQuoteImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7ee2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a7ee2f')) {
      api.createRecord('76a7ee2f', component.options)
    } else {
      api.reload('76a7ee2f', component.options)
    }
    module.hot.accept("./OrmQuoteImages.vue?vue&type=template&id=76a7ee2f&scoped=true", function () {
      api.rerender('76a7ee2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/orm/components/OrmQuoteImages.vue"
export default component.exports